export const LINK = 'link';
export const PARAGRAPH = 'paragraph';
export const VALID_PROTOCOLS = [
  'http',
  'https',
];
